<div class="freq-semana">
  <p class="freq-semana-toolbar">
    <a routerLink="/dashboard" nbButton size="small" status="basic" outline>← Voltar ao painel</a>
    <button type="button" nbButton size="small" status="basic" ghost (click)="carregar()">Atualizar</button>
  </p>

  <nb-card class="lista-crud" *ngIf="erro && !carregando">
    <nb-card-body class="freq-semana-erro">{{ erro }}</nb-card-body>
  </nb-card>

  <nb-card *ngIf="carregando">
    <nb-card-body class="freq-semana-loading">
      <nb-spinner status="primary"></nb-spinner>
      <span>Carregando…</span>
    </nb-card-body>
  </nb-card>

  <ng-container *ngIf="dados && !carregando && !erro">
    <p class="freq-semana-legenda">Semana de referência (semana anterior à atual): <strong>{{ periodoTexto }}</strong></p>

    <nb-card class="lista-crud">
      <nb-card-header class="head">
        <div class="titulo-bloco">
          <span class="titulo-principal">Turmas ativas sem chamada na semana</span>
          <span class="titulo-contexto"
            >Nenhum registro de frequência em qualquer dia desta semana.</span
          >
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="smart-table-wrap" *ngIf="dados.turmasSemChamada?.length; else vazioSemChamada">
          <table class="smart-table">
            <thead>
              <tr>
                <th>Turma</th>
                <th class="col-ano">Ano</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of dados.turmasSemChamada; trackBy: trackByTurma">
                <td data-label="Turma"><strong>{{ t.nome }}</strong></td>
                <td class="col-ano" data-label="Ano">{{ t.ano ?? '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #vazioSemChamada>
          <p class="vazio">Todas as turmas ativas possuem ao menos um registro de frequência nesta semana.</p>
        </ng-template>
      </nb-card-body>
    </nb-card>

    <nb-card class="lista-crud freq-semana-card-faltas">
      <nb-card-header class="head">
        <div class="titulo-bloco">
          <span class="titulo-principal">Faltas no encontro (semana)</span>
          <span class="titulo-contexto">Registros com presença “não” na semana, por turma e catequizando.</span>
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="freq-semana-filtro" *ngIf="turmasParaFiltro.length">
          <label class="field-label" for="filtroTurmaFaltas">Turma</label>
          <select
            id="filtroTurmaFaltas"
            class="freq-semana-select"
            name="filtroTurma"
            [(ngModel)]="filtroTurmaId"
          >
            <option [ngValue]="null">Todas as turmas</option>
            <option *ngFor="let op of turmasParaFiltro" [ngValue]="op.id">{{ op.nome }}</option>
          </select>
        </div>

        <div class="smart-table-wrap" *ngIf="faltasFiltradas.length; else vazioFaltas">
          <table class="smart-table">
            <thead>
              <tr>
                <th>Turma</th>
                <th>Catequizando</th>
                <th class="col-num">Faltas na semana</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of faltasFiltradas; trackBy: trackByFalta">
                <td data-label="Turma">{{ f.turmaNome }}</td>
                <td data-label="Catequizando">{{ f.pessoaNome }}</td>
                <td class="col-num" data-label="Faltas na semana">{{ f.totalFaltasNaSemana }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #vazioFaltas>
          <p class="vazio">Nenhuma falta registrada no encontro nesta semana (ou nenhuma no filtro atual).</p>
        </ng-template>
      </nb-card-body>
    </nb-card>
  </ng-container>
</div>
